import logo from '../assets/imgs/unicred/logo.svg'
import logo_white from '../assets/imgs/unicred/logo.svg'

export default {
    logo,
    logo_white,
    name: "Unicred",
    title: "Unicred Assembleias",
    appcode: 2,
    captchaSiteKey: "6LebO8IhAAAAAApCTVQlIKAmnnP2suTrTsWAuAUk",
    facebookAppId: "",
    googleAppId: "",
    googleTrackingId: "G-J2CRKSSP2R",
    showPA: true,
    showGroup: false,
    allowPublicMessages: true,
    allowPrivateMessages: true,
    accessCodeByEmail: false,
    enableGuestAccess: true,
    showMyLivestreamsOnly: false,
    prePollTitle: "Pré Assembleia",
    showMyLivestreamsByAgencyAndGroup: false,
    showBallotPaper: false
};
